import React from 'react'
import {Container, Dropdown} from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { Link } from 'react-router-dom'
import { useAuth } from '../auth/useAuth'

export default function MenuAdmin( { toggleSidebar , isCollapsed} ) {
	const { t } = useTranslation()
	const { logoutClient } = useAuth()

  	return (
		<Container className="d-flex justify-content-end">
			<Dropdown className='ms-auto'>
				<Dropdown.Toggle variant='drop' id="dropdown-basic" className='ms-auto'>
					<i className="fas fa-bars"></i>
				</Dropdown.Toggle>
				<Dropdown.Menu>
					<Dropdown.Item as={Link} to="/" onClick={logoutClient}><img src="/images/menus/logout.svg" alt={t('menus.logout')}/> {t('menus.logout')}</Dropdown.Item>
				</Dropdown.Menu>
			</Dropdown>
		</Container>
	)
}